import React from "react";

export function ClientFormatter(cellContent, row, rowIndex, {clientsToRemove}){

    const getClientName = () => {
        const currClient = clientsToRemove.find(client => client == row._id)
        if(currClient) {
            return (
                <span className="text-danger font-weight-bolder d-block font-size-lg">
                    { row.businessName }
                </span>
            )
        } else {
            return (
                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                    { row.businessName }
                </span>
            )
        }
        
    }

    return(
        <>
            {getClientName()}
        </>
    )
}